import apiService from './api-service';
import { utilsService } from "./utils-service";
import { filterService } from "./filter-service";

export const chartService = {
	getCharts,
	getFuelChart
};

async function getCharts() {
	const charts = await apiService.get('chart/getCharts');

	return charts;
}

async function getFuelChart(beginTime, endTime, charts, isAccountingSystem, selectedValues, selectedFilter, fuelTanks) {
	let tankIds = [];

	if (selectedFilter == filterService.TANK_IDS_FILTER) {
		tankIds = selectedValues.values.map(item => { return item.key });
	} else if (selectedFilter == filterService.COMPANY_ID_FILTER) {
		tankIds = filterService.getFilterValuesByCompanies(fuelTanks, selectedValues).split(",");
	} else if (selectedFilter == filterService.DEPO_FILTER) {
		tankIds = filterService.getFilterValuesByDepos(fuelTanks, selectedValues).split(",");
	}

	const parameters = {
		beginTime: utilsService.formatDateTime(beginTime),
		endTime: utilsService.formatDateTime(endTime),
		charts: charts.map(item => { return item.key }),
		tankIds: tankIds
	};

	const fuelChart = isAccountingSystem
		?
		await apiService.post('chart/getFuelChartAccountingSystem', parameters)
		:
		await apiService.post('chart/getFuelChart', parameters);

	return fuelChart;
}
